import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget } from '@eforall/dashboard';
import { PersonEmailSent } from '@interfaces';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { StaticDataService } from '../../../../services';
import { PersonExplorerService } from '../person-explorer.service';
import { getSetup } from "./grid/get-setup";

export interface EmailSentRow extends PersonEmailSent {
	email: string,
	highestEventName: string,
}

@Component({
	selector: 'person-emails-sent-part',
	standalone: true,
	imports: [
		TabStripModule,
		GridContentWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-emails-sent.part.html'
})

export class PersonEmailsSentPart {

	#util = inject(UtilityService);
	#staticData = inject(StaticDataService);
	#dialog = inject(DialogService);
	personExplorer = inject(PersonExplorerService);
	public setup = getSetup(this.#util, this.#dialog);


	public emailsSent = computed(() => {
		const data = this.personExplorer.person.value();

		if (!data) return [];

		const emailById = this.#util.array.toMap(data.general.otherEmails, e => e.emailId);

		return data.emailsSent.map(e => {
			return {
				...e,
				email: e.emailId === data.general.primaryEmailId ? data.general.primaryEmail : emailById[e.emailId]!.email, // if not primary email, then it must be in otherEmails
				highestEventName: this.#staticData.mailgun_event_types.byId(e.highestMailgunEventTypeId).name,
			}
		});
	});
}